
import { mapGetters, mapActions } from 'vuex';
export default {
    components: {
        sliderVideo			: () => import('../../components/home/slider-video.vue'),
        productCollection	: () => import('../../components/product/product-collection.vue'),
        logoSlider			: () => import('../../components/home/logo-slider.vue'),
        faq					: () => import('../../components/account/faq.vue'),
        vcDynamicLink		: () => import('../../components/pages/dynamic-link.vue'),
        vcCountUp		    : () => import('../../components/pages/countup.vue'),
        testimonial			: () => import('../../components/home/testimonial.vue')
    },
    data() {
        return {
            isLoading					: true,
            collection_products			: [],
            bussines_image_sizes            : [
            "xs:300px",
            "sm:320px",
            "md:400px",
            "lg:500px",
            ],
            service_image_sizes            : [
            "xs:300px",
            "sm:320px",
            "md:400px",
            "lg:500px",
            ],
            cateogry_product_image_sizes: [
            "xs:180px",
            "sm:250px",
            "md:400px",
            "lg:280px",
            "xl:320px",
            "2xl:350px"
            ],
            swipper_services_options: {
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 3,
                        loop: true
                    },
                    640: {
                        slidesPerView: 2,
                        loop: true
                    }
                }
            },
            swipper_first_order_options: {
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                loop: true
            },
            swipper_goals_options: {
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 2
                    },
                    640: {
                        slidesPerView: 1
                    }
                }
            },
            swipper_products_options: {
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: {
                    delay: 12000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 4
                    },
                    991: {
                        slidesPerView: 3
                    },
                    768: {
                        slidesPerView: 2
                    },
                    640: {
                        slidesPerView: 1
                    }
                }
            },
            swipper_products_categories: {
                slidesPerView: 2,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 4
                    },
                    991: {
                        slidesPerView: 3
                    },
                    768: {
                        slidesPerView: 2
                    },
                    640: {
                        slidesPerView: 2
                    }
                }
            },
            execute_counts_up: false
        }
    },
    async mounted() {
        window.addEventListener('load', this.loadPage);
        window.addEventListener('scroll', this.loadPage);
        
        await this.getCollectionHome();
    },
    computed: {
        ...mapGetters({
            getterCollectionHome: 'getterCollectionHome',
            getterBasicData: 'getterBasicData',
            getterHomeMetrics: 'getterHomeMetrics'
        }),
        getterCallPhone(){
            return this.getterBasicData?.contact_information.phones.find( (item) => item.call );
        }
    },
    methods: {
        ...mapActions({
            getCollectionHome: 'getCollectionHome'
        }),
        loadPage(event){ 
            const targetSection = document.getElementById('section-goals');
            const rect = targetSection.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
            
            if (this.execute_counts_up === false && isVisible) {
                console.log('Target section is visible');
                this.$root.$emit("init-count-up", 'count-up-customers');
                this.$root.$emit("init-count-up", 'count-up-orders');
                this.$root.$emit("init-count-up", 'count-up-brands');
                this.$root.$emit("init-count-up", 'count-up-operate');
                this.execute_counts_up = true;
            }
        }
    }
}
